<div class="header">
  <nav class="navbar navbar-expand-lg  navbar-light bg-light custom-navbar" [ngClass]="isSticky ? 'sticky-header': 'fixed-header' " (scroll)="checkScroll($event)" >
    <a class="navbar-brand brand-logo" routerLink="/home">
      <img [src]="logo" alt="SwadhaAgri" />
    </a>
  
    <div class="for-phone-only">
      <button type="button" class="btn btn-lg btn-accent d-block d-sm-none">
 
        <a class="nav-link app-btn " href="https://franchise.swadhaagri.com/" target="_blank">Become Franchise</a>
      </button>
       
      
      <button class="navbar-toggler" (click)="collapsed = !this.collapsed" type="button"  data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon" ></span>
      </button>
    </div>
  
    <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngClass]="{ collapse: collapsed, 'navbar-collapse': true }">
      <ul class="navbar-nav mx-auto">
        <li class="nav-item active" navItem>
          <a class="nav-link" routerLink="/home" routerLinkActive="active" (click)="collapsed = true">Home</a>

          <!-- <label class="nav-link" routerLink="/home" role="button"  routerLinkActive="active" (click)="collapsed = true" >Home </label> -->
        </li>
        
        <li class="nav-item" navItem>
          <a class="nav-link" routerLink="/products" routerLinkActive="active" (click)="collapsed = true">Products</a>

          <!-- <label class="nav-link" role="button" routerLink="/products" routerLinkActive="active" (click)="collapsed = true"  >Products</label> -->
        </li>
  
        
        <li class="nav-item" >
          <a class="nav-link" routerLink="/aboutus" routerLinkActive="active" (click)="collapsed = true">About</a>

          <!-- <label class="nav-link" routerLink="/aboutus" role="button" routerLinkActive="active" (click)="collapsed = true">About</label> -->
        </li>
      </ul>
    <ul class="navbar-nav d-none d-sm-block">
        <!-- <li  routerLink="" role="button" class="nav-item btn btn-lg btn-accent" (click)="collapsed = true" ><a class="nav-link app-btn" href="https://play.google.com/store/apps/details?id=com.mkt.swadha" target="_blank">Download App</a></li> -->

        <li  routerLink="" class="nav-item btn btn-lg btn-accent" (click)="collapsed = true" ><a class="nav-link app-btn" href="https://franchise.swadhaagri.com/" target="_blank">Become Franchise</a></li>
      </ul>
      <!-- <ul class="navbar-nav d-none d-sm-block"> -->
        <!-- <li  routerLink="" role="button" class="nav-item btn btn-lg btn-accent" (click)="collapsed = true" ><a class="nav-link app-btn" href="https://play.google.com/store/apps/details?id=com.mkt.swadha" target="_blank">Download App</a></li> -->

        <!-- <li  routerLink="" class="nav-item btn btn-lg btn-accent" (click)="collapsed = true" ><a class="nav-link app-btn" href="https://play.google.com/store/apps/details?id=com.mkt.swadha" target="_blank">Download App</a></li>
      </ul> -->
      
    </div>
    
  
  </nav>
</div>